import './FemaleStyles.css';

function FemaleStyles() {
return ( 
    <h3 className='Female'>
    Female Style
    </h3>
);
}
export default FemaleStyles;